import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ButtonComponent from "@ui/components/Button/Button.component";
import ButtonBarComponent from "@ui/components/Button-bar/Button-bar.component";
import ModalComponent from "@ui/components/Modal/Modal.component";
import { IProps } from "./IState";

const Component: React.FC<IProps> = ({
    lang,
    loading,
    loadold,
    loginactive,
    onSignInClick,
    onBtnKeyDown,
    onClose,
}: IProps) => {
    return (
        <ModalComponent
            className="add-group"
            title="addDeviceInOldDbSuccess"
            lang={lang}
            loadold={loadold}
            loading={loading}
            onClose={onSignInClick}
            onBtnKeyDown={onBtnKeyDown}
        >
            <Box className="add-device" component="section">
                <Typography className="device-info__title-text" variant="h6">
                    <p>
                        Аккаунт Вега-М успешно добавлен
                    </p>
                </Typography>
                <ButtonComponent
                    label="ok"
                    lang={lang}
                    onClick={onSignInClick}
                    onKeyDown={onBtnKeyDown}
                />
                {/* <ButtonBarComponent >
                    
                </ButtonBarComponent> */}
            </Box>
        </ModalComponent>
    );
};

const AddOldDeviceComponent = React.memo(Component);

export default AddOldDeviceComponent;
